import { EmptyState } from '@sjuni/ui';
import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router-dom';

/**
 * An admin URL that matches nothing, and the boundary for anything that throws
 * on the way to one.
 *
 * Without it React Router draws its own "Unexpected Application Error!" — an
 * English stack trace, on a Georgian-first dashboard, for something as ordinary
 * as a bookmark to a record that has since been deleted. §6.3 and §6.4 both
 * rule that out.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  // `useRouteError` returns undefined when this renders as an ordinary route
  // rather than as an `errorElement`, which is how the two cases are told apart.
  const crashed = error !== undefined && error !== null;

  return (
    <div className="grid min-h-screen place-items-center p-6">
      <div className="w-full max-w-md text-center">
        <EmptyState
          title={crashed ? t('errors.crashTitle') : t('errors.notFoundTitle')}
          description={crashed ? t('errors.crashBody') : t('errors.notFoundBody')}
        />

        <p className="mt-6">
          <Link to="/" className="text-body-sm text-link underline-offset-2 hover:underline">
            {t('errors.backToDashboard')}
          </Link>
        </p>
      </div>
    </div>
  );
}
